export default __webpack_public_path__ + "static/media/queens-gambit.d52c7e6e.txt";